import { useTranslation } from 'react-i18next';
import { useGetFeedback } from 'src/hooks';
import type { TReviewFormState } from 'src/types';

type Props = {
  setReviewFormState: React.Dispatch<React.SetStateAction<TReviewFormState>>;
};

export const FeedbackModalReviewCTA = ({
  setReviewFormState,
}: Props) => {
  const { t } = useTranslation();
  const { isFirstShow } = useGetFeedback();
  const firstShow = isFirstShow();

  return (
    <div className='flex w-full flex-col items-center gap-6'>
      <img
        src='https://assets.share-a-cart.com/images/next/celebration.webp'
        alt='Celebration'
        width={144}
        height={139}
        className='rounded-[32px] object-cover'
      />
      <div className='flex flex-col items-center gap-4 text-center text-primary-dark'>
        <h2 className='font-primary text-2xl font-bold leading-tight'>
          {firstShow
            ? t('get.hey_you_just_received_your_first_cart')
            : t('get.hey_we_love_hearing_from_our_users')}
        </h2>
        <p className='font-secondary text-base leading-relaxed'>
          {firstShow
            ? t('get.how_was_it_for_you')
            : t('get.how_are_you_finding_sac')}
        </p>
      </div>
      <div className='flex w-full gap-2'>
        <button
          onClick={() => setReviewFormState('sad')}
          className='flex h-12 flex-1 items-center justify-center gap-1 rounded-full bg-accentOrange px-2 font-secondary text-base font-bold text-[#461a0b] transition-colors hover:bg-accentOrange/90'
        >
          <span className='text-[32px] leading-none'>😩</span>
          {t('get.not_great')}
        </button>
        <button
          onClick={() => setReviewFormState('happy')}
          className='flex h-12 flex-1 items-center justify-center gap-1 rounded-full bg-grassGreen px-2 font-secondary text-base font-bold text-[#461a0b] transition-colors hover:bg-grassGreen/90'
        >
          <span className='text-[32px] leading-none'>😀</span>
          {t('get.great')}
        </button>
      </div>
    </div>
  );
};
